import type { IconData } from '@stacksjs/iconify-core'

export const dropbox: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M16.53 10.091L21 12.939l-4.502 2.868L12 12.941l-4.498 2.866L3 12.939l4.47-2.848L3 7.243l4.502-2.868L12 7.241l4.498-2.866L21 7.243z\" clip-rule=\"evenodd\"/><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M16.467 10.091L12 7.245l-4.467 2.846L12 12.936z\" clip-rule=\"evenodd\" opacity=\".25\"/><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m7.531 16.757l-.029-.95L12 12.941l4.498 2.866l.036.95l-4.502 2.868z\" clip-rule=\"evenodd\" opacity=\".5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default dropbox
